import type { FormConfig } from '../types';
import beforeYouStart from '../pages/reward/beforeYouStart';
import nomineeDetails from '../pages/reward/nomineeDetails';
import nominatorDetails from '../pages/reward/nominatorDetails';
import rewardDetails from '../pages/reward/rewardDetails';
import approval from '../pages/reward/approval';
import approvalContextTables from '../pages/reward/approvalContextTables';

const formConfig: FormConfig = {
  live: true,
  id: 'reward',
  formName: 'Reward & Recognition Form',
  title: 'Cabinet Office Digital reward and recognition nomination form',
  subTitle: 'Summary page',
  showSections: true,
  approval: 'always',
  approvalRequestHint: 'Add anything additional that might be useful for the panel to know',
  approvalDecisionHint:
    'If you reject this form, the nominator will have the option to update and resubmit it.',
  approvalCommentHint:
    'This will be shared with the <strong>nominator</strong>. Please include details around changes in value or decline comments. This could include advice to resubmit the nomination if further details are required.',
  approvalAllowUnsubmit: false,
  approvalFixedEmail: 'admin',
  approveFormCondition: 'approve',
  rewardFormLocation: 'bottom',
  approvalContextTables,
  feedbackEmail: 'co-digital-reward@cabinetoffice.gov.uk',
  statusOverride: {
    approval: 'Awaiting panel decision',
  },
  identifier: '{team-name|nominee-full-name}, {approval-reward-voucher-other-amount|approval-reward-voucher-amount|approval-iyb-amount|reward-voucher-other-amount|reward-voucher-amount|iyb-amount}, {responsible-function-area|nominee-function}',
  sections: [
    {
      title: 'Start',
      slug: 'start',
      subsections: [
        {
          title: 'Before you start',
          slug: 'before-you-start',
          pages: beforeYouStart,
        },
      ],
    },
    {
      title: 'Nominator',
      slug: 'nominator',
      subsections: [
        {
          title: 'Nominator details',
          slug: 'nominator-details',
          pages: nominatorDetails,
        },
      ],
    },
    {
      title: 'Nomination',
      slug: 'nomination',
      subsections: [
        {
          title: 'Nominee details',
          slug: 'nominee-details',
          pages: nomineeDetails,
        },
      ],
    },
    {
      title: 'Reward',
      slug: 'reward',
      subsections: [
        {
          title: 'Reward details',
          slug: 'reward-details',
          pages: rewardDetails,
        },
      ],
    },
    {
      title: 'Approvals',
      slug: 'approvals',
      subsections: [
        {
          title: 'Approval',
          slug: 'approval',
          pages: approval,
        },
      ],
    },
  ],
};

export default formConfig;
